import script from "./ContentFeaturedLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentFeaturedLinks.vue?vue&type=script&setup=true&lang=ts"

import "./ContentFeaturedLinks.vue?vue&type=style&index=0&id=9df8bb14&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9df8bb14"]])

export default __exports__